import type { SVGProps } from 'react';
import * as React from 'react';

const FilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/filter">
      <path
        id="Icon"
        d="M3 5.75H21M6.5 12H17.5M10 18.25H14"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default FilterIcon;
